import { formatItemTime } from "@/components/Dispatch/format";
import { type DriverRow, isSamsaraVehicleNameTag, type TagDefinition } from "@/types/driver";

/** A "changed HH:mm" style footnote for a status timestamp, or null when the time is unknown. */
export function changedAt(iso: string | null | undefined, verb = "changed"): string | null {
  const time = formatItemTime(iso);
  return time ? `${verb} ${time.short}` : null;
}

/** The em dash shown when a tile has no value. */
export const NO_VALUE = "—";

/**
 * The driver's first value for the first workspace tag the predicate picks that carries one; null when none does.
 */
export function firstTagValue(
  driver: Pick<DriverRow, "tags">,
  tags: readonly TagDefinition[],
  matches: (tag: TagDefinition) => boolean,
): string | null {
  return (
    tags
      .filter(matches)
      .map((tag) => driver.tags[tag.id]?.[0])
      .find((value) => value !== undefined && value !== "") ?? null
  );
}

/** The unit number of the truck the driver runs, off the workspace's vehicle-name tag; null when the driver has none. */
export function unitNumber(driver: Pick<DriverRow, "tags">, tags: readonly TagDefinition[]): string | null {
  return firstTagValue(driver, tags, isSamsaraVehicleNameTag);
}
